export default __webpack_public_path__ + "static/old_man-db5320f66c6f74e5f82eff96841eaa15.png";